// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  display: none;
}

ion-input.date-picker {
  --padding-top: 0.25rem;
}

ion-modal.date-picker-modal {
  --width: auto;
  --height: auto;
}

.mat-picker {
  margin-right: 0rem !important;
  display: flex;
  flex-grow: 1;
}

::ng-deep mat-form-field.no-errors .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep mat-form-field.no-errors .mat-mdc-form-field-subscript-wrapper.mat-mdc-form-field-bottom-align {
  display: none !important;
}

:host ::ng-deep mat-form-field .mat-mdc-form-field-icon-suffix {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}

::ng-deep mat-form-field .mat-mdc-text-field-wrapper {
  height: 51px !important;
  font-size: 15px !important;
  --mdc-outlined-text-field-error-label-text-color: #c5000f;
}
@media (max-width: 768px) {
  ::ng-deep mat-form-field .mat-mdc-text-field-wrapper {
    font-size: 14px !important;
  }
}
::ng-deep mat-form-field .mat-mdc-text-field-wrapper mat-error {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #c5000f;
}

.picker-disabled {
  opacity: 0.6;
}
.picker-disabled input {
  cursor: not-allowed;
}

.custom-error {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #c5000f;
  display: flex;
  max-height: 48px;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/date-picker-input/date-picker-input.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AACA;EACE,aAAA;EACA,cAAA;AAEF;;AACA;EACE,6BAAA;EACA,aAAA;EACA,YAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EAGE,wBAAA;AAAF;;AAMA;EACE,6BAAA;EACA,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,0BAAA;EAYA,yDAAA;AAdF;AAIE;EAJF;IAKI,0BAAA;EADF;AACF;AAGE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AADJ;;AAOA;EACE,YAAA;AAJF;AAME;EACE,mBAAA;AAJJ;;AAQA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AALF","sourcesContent":[".hidden {\n  display: none;\n}\n\nion-input.date-picker {\n  --padding-top: 0.25rem;\n}\nion-modal.date-picker-modal {\n  --width: auto;\n  --height: auto;\n}\n\n.mat-picker {\n  margin-right: 0rem !important;\n  display: flex;\n  flex-grow: 1;\n}\n\n::ng-deep mat-form-field.no-errors .mat-mdc-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n::ng-deep\n  mat-form-field.no-errors\n  .mat-mdc-form-field-subscript-wrapper.mat-mdc-form-field-bottom-align {\n  display: none !important;\n}\n\n// `:host` obrigatório: `::ng-deep` sozinho compila sem atributo de escopo e a regra\n// passa a valer no documento inteiro assim que este componente é instanciado — era o\n// que jogava o sufixo (\"cm\", \"kg\", \"litros\") de Cadastrar veículo para o topo do campo.\n:host ::ng-deep mat-form-field .mat-mdc-form-field-icon-suffix {\n  position: absolute !important;\n  right: 0 !important;\n  top: 0 !important;\n}\n\n::ng-deep mat-form-field .mat-mdc-text-field-wrapper {\n  height: 51px !important;\n  font-size: 15px !important;\n\n  @media (max-width: 768px) {\n    font-size: 14px !important;\n  }\n\n  mat-error {\n    margin-top: 8px;\n    font-size: 0.75rem;\n    color: #c5000f;\n  }\n\n  --mdc-outlined-text-field-error-label-text-color: #c5000f;\n}\n\n.picker-disabled {\n  opacity: 0.6;\n\n  input {\n    cursor: not-allowed;\n  }\n}\n\n.custom-error {\n  margin-top: 8px;\n  font-size: 0.75rem;\n  color: #c5000f;\n  display: flex;\n  max-height: 48px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
